import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { BrandfolderHexColors } from '../../../../enums/colors.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import { BaseButton } from '../base-button/base-button.js';

const BaseColorButton = (props)=>{
    const { 'aria-label': ariaLabel, backgroundColor, className, style, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseButton, {
        ...otherProps,
        "aria-label": ariaLabel,
        className: classnames({
            'bf-button__color': true,
            [`${className}`]: !!className
        }),
        style: {
            ...style,
            backgroundColor
        }
    });
};
const Color = styled(BaseColorButton)`
  border-color: ${BrandfolderHexColors.GrayBorder};
  border-width: 1px;
  border-style: solid;
  border-radius: 50%;
  cursor: pointer;
  height: 24px;
  padding: 0;
  transition: filter 0.2s ease;
  width: 24px;

  &:focus-visible,
  &:hover {
    filter: brightness(80%);
  }
`;
const ColorButton = (props)=>{
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Color, props));
};

export { ColorButton };
//# sourceMappingURL=color-button.js.map
